const baseFeatures = {
  floatingOffsets: true,
  globalCounters: true,
  ...(window.SiteFeatures ?? {})
};

import { initFloatingOffsetHandling } from './utils/floating-offset.js';
import { initGlobalCounters, initNumberCounters, destroyNumberCounters } from './ui/count-animations.js';
import './core/app-init.js';

if (baseFeatures.floatingOffsets) {
  initFloatingOffsetHandling();
}

if (baseFeatures.globalCounters) {
  initGlobalCounters();
}

export { initNumberCounters, destroyNumberCounters };
